import * as React from "react";
 const Toaster = ({ open,isSuccess,msg }) => (
  open ? <div className={`toaster-pop ${isSuccess?'toaster-success':'toaster-failure'}`}>
    {isSuccess ? <SuccessIcon /> : <WarningIcon />}
    <p>{msg}</p></div> : null);

export default Toaster;

 const WarningIcon = ()=>{
  return(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="toaster-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#cc0000"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      width="20"
      height="20"
    >
      <path d="M10.29 3.86L1.82 18a1 1 0 0 0 .87 1.5h18.62a1 1 0 0 0 .87-1.5L13.71 3.86a1 1 0 0 0-1.72 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12" y2="17" />
    </svg>)}
  
  const SuccessIcon = ()=>{
    return(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="toaster-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
      width="20"
      height="20"
    >
      <path d="M20 6L9 17l-5-5" />
    </svg>
                )}